/**
 * @module
 *
 * @description Small Medium Business Loans drivers
 */
import { getAprMax, getAprMin, getAprTooltip, getFicoMin } from '../selectors/small-medium-business-loans';
import { getPercentageRange } from '../utils/format';
import { VALUE_SIZES } from '../constants/drivers';
/**
 * Get the estimated APR driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverEstimatedApr = function getDriverEstimatedApr(offer) {
  return {
    id: 'estApr',
    label: 'Est. APR',
    value: getPercentageRange(getAprMin(offer), getAprMax(offer)),
    valueSize: VALUE_SIZES.MEDIUM,
    valueTooltip: getAprTooltip(offer)
  };
};
/**
 * Get the min credit score driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverMinCreditScore = function getDriverMinCreditScore(offer) {
  return {
    id: 'minCreditScore',
    label: 'Min. credit score',
    value: getFicoMin(offer) || 'Not provided',
    valueSize: VALUE_SIZES.MEDIUM
  };
};